<div
  class="fixed inset-0 z-[110] flex items-center justify-center bg-black/40 backdrop-blur-sm"
  (click)="onCancel.emit()">
  <div
    class="animate-in fade-in zoom-in relative w-[400px] rounded-xl bg-white p-8 text-center shadow-xl duration-200"
    (click)="$event.stopPropagation()">
    <button
      (click)="onCancel.emit()"
      class="absolute top-4 cursor-pointer rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
      [ngClass]="isArabic() ? 'left-4' : 'right-4'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
      <svg
        class="stroke-danger-text"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      </svg>
    </div>

    <h2 class="mb-2 text-xl font-bold text-red-600">{{ translations().title }}</h2>
    <p class="mb-8 text-sm text-gray-500">
      {{ translations().description }}
      @if (!customDescription() && itemName()) {
        <span class="text-primary font-bold">{{ itemName() }}</span>
        .
      }
    </p>

    <div class="flex gap-3" [ngClass]="isArabic() ? 'flex-row-reverse' : 'flex-row'">
      <button
        (click)="onCancel.emit()"
        class="flex-1 cursor-pointer rounded-lg border py-2.5 font-bold text-gray-600 transition-colors hover:bg-gray-50">
        {{ translations().cancel }}
      </button>
      <button
        (click)="onConfirm.emit()"
        class="bg-primary hover-bg-primary-hover flex-1 cursor-pointer rounded-lg py-2.5 font-bold text-white transition-all">
        {{ translations().delete }}
      </button>
    </div>
  </div>
</div>
